import React, { FC, useEffect, useState } from "react"
import { observer } from "mobx-react"
import { useStore } from "stores/utils/use-store"
import {
  CreateGamePublisher,
  GameAttributionPlatform,
  GamePublisher,
} from "../store/game-publishers.store"
import { ColumnsType } from "antd/lib/table"
import { EditIconButton } from "components"
import { gamePublisherColumns } from "./columns"
import InfiniteScroll from "components/InfiniteScroll"
import { Button, Form, Input, Modal, Select, Table } from "antd"
import { notifications } from "notifications"

export const GamePublishers: FC = observer<FC>(() => {
  const [editPublisher, setEditPublisher] = useState<GamePublisher | null>(null)
  const [isAddPublisherModalOpen, setIsAddPublisherModalOpen] = useState<boolean>(false)
  const { dataStore: { gamePublishersStore } } = useStore()
  const [form] = Form.useForm()

  useEffect(() => {
    gamePublishersStore.getData().then()
  }, [gamePublishersStore])

  useEffect(() => {
    if (editPublisher) {
      form.setFieldsValue(editPublisher)
    }
  }, [editPublisher, form])

  const onFinishHandler = async(values: CreateGamePublisher) => {
    try {
      if (editPublisher) {
        await gamePublishersStore.updateGamePublisher(editPublisher.id, values)
        notifications.success("Game Publisher updated successfully")
        setEditPublisher(null)
        form.resetFields()
      } else {
        await gamePublishersStore.createGamePublisher(values)
        notifications.success("Game Publisher created successfully")
        setIsAddPublisherModalOpen(false)
        form.resetFields()
      }
    } catch (err: any) {
      notifications.error(err?.message || "Failed to proceed")
    }
  }

  const columns: ColumnsType<GamePublisher> = [
    ...gamePublisherColumns,
    {
      title: "Update Publisher",
      dataIndex: "update",
      key: "update",
      render: (_, data) => (
        <EditIconButton
          onClick={() => {
            setEditPublisher(data)
          }}
        />
      ),
    },
  ]

  return (
    <>
      <div
        style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}
      >
        <h1 style={{ fontSize: 24 }}>Game Publishers</h1>
        <Button
          type="primary"
          onClick={() => setIsAddPublisherModalOpen(true)}
        >
          Add Publisher
        </Button>
      </div>

      <Table
        dataSource={gamePublishersStore.gamePublishers || []}
        columns={columns}
        rowKey="id"
        pagination={false}
        loading={gamePublishersStore.isLoading}
      />

      <InfiniteScroll
        onLoadMore={() => {
          gamePublishersStore.loadedPages += 1
          gamePublishersStore.getData()
        }}
        isLoading={gamePublishersStore.isLoading}
        hasMore={
          gamePublishersStore.gamePublishers?.length < gamePublishersStore.total
        }
      />
      <Modal
        open={!!editPublisher || isAddPublisherModalOpen}
        title={editPublisher ? "Edit Game Publisher" : "Add New Game Publisher"}
        onCancel={() => {
          form.resetFields()
          setEditPublisher(null)
          setIsAddPublisherModalOpen(false)
        }}
        footer={null}
        width={600}
      >
        <Form layout="vertical" form={form} onFinish={onFinishHandler} >
          <Form.Item>
            <Form.Item
              label="Name"
              name="name"
              rules={[{ required: true, message: "Publisher name is required" }]}
            >
              <Input placeholder="Please enter publisher name" />
            </Form.Item>
            <Form.Item
              label="Cost Reporting Platform"
              name="costReportingPlatform"
              rules={[{ required: true, message: "Cost Reporting Platform is required" }]}
            >
              <Select
                placeholder="Please select a platform"
                options={Object.keys(GameAttributionPlatform).map(key => ({
                  label: key,
                  value: key,
                }))}
              />
            </Form.Item>
          </Form.Item>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              onClick={() => {
                form.resetFields()
                setEditPublisher(null)
                setIsAddPublisherModalOpen(false)
              }}
            >Cancel
            </Button>
            <Button type="primary" htmlType="submit">
                Save
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  )
})
